import { render, staticRenderFns } from "./PaypalButton.vue?vue&type=template&id=8a4f6904"
import script from "./PaypalButton.vue?vue&type=script&lang=js"
export * from "./PaypalButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports